// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"yq-z","title":"zq-z","nav":"Aq-z","flexCell":"Bq-z","facetLink":"Cq-z"};